export default "/images/vendor/flag-icons/flags/4x3/dg.svg?36fbc663af1f1f23966d941f4c9c79f5";